/**
 * Shared chat bubble styling.
 *
 * Replaces the `conv-text-message-bot` / `conv-text-message-user` classes, which
 * were referenced by every message component but never actually defined in any
 * stylesheet - so the bubbles rendered transparent. Keeping this as one exported
 * helper means the bot/user treatment cannot drift apart again across the four
 * components that render bubbles.
 */

const BASE = 'inline-flex flex-col gap-0.5 rounded-2xl px-3 py-2 text-sm shadow-sm max-w-md';

// The bot speaks in the app's neutral surface, the operator in the accent
// colour, so the two sides stay distinguishable at a glance without relying on
// alignment alone.
const BOT = 'bg-white text-gray-800 ring-1 ring-inset ring-gray-200 rounded-bl-sm';
const USER = 'bg-indigo-600 text-fixed-white rounded-br-sm';

export function bubbleClass(isBot) {
    return `${BASE} ${isBot ? BOT : USER}`;
}

/**
 * Timestamp colour, which has to invert inside the accent bubble to stay legible.
 */
export function bubbleDateClass(isBot) {
    return isBot ? 'text-gray-400' : 'text-indigo-200';
}
